import { colors } from 'theme'

export const defaultThemeStyles: {
    [index: string]: string
} = {
    ping: colors.ping,
    online: colors.online,
    offline: colors.offline,
    sleep: colors.sleep,
    offlineGroup: colors.offline,
    onlineDisplayOff: colors.online_display_off,
    idle: colors.darkCloud,
    progress: colors.darkCloud,
    backgroundMain: colors.grey,
    backgroundSub: colors.greyLight,
    textMain: colors.white,
    titleBackground: 'rgba(0, 0, 0, 0.45)',
    error: colors.error,
    active: 'rgba(0, 0, 0, 0.28)',
    shadow: '-1px 3px 4px 0px rgba(0, 0, 0, 0.25)',
    noBroadcastText: colors.white,
    iconWrapper: colors.white,
    panel: colors.white,
}
